import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "fixed-bottom mx-auto d-flex justify-content-center" }
const _hoisted_2 = { class: "page-nav d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "col-6"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 2,
  class: "d-block d-sm-inline-block p-4"
}
const _hoisted_8 = { class: "page-nav-number text-center" }
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = {
  key: 0,
  class: "m-0"
}
const _hoisted_11 = { class: "next" }
const _hoisted_12 = ["href"]

import { onMounted, ref, computed } from "vue";
import { workflow } from "@/guiide/ts/workflow/workflow";
import { WorkflowStep } from "@/guiide/ts/workflow/workflowStep";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'PageNav',
  props: {
  backLink: { type: String, required: false },
  nextLink: { type: String, required: false },
  nextText: { type: String, required: false, default: "Next" },
  customLink: { type: String, required: false },
  customText: { type: String, required: false },
  showBack: { type: Boolean, default: true },
  showNext: { type: Boolean, default: true },
  showCustom: { type: Boolean, required: false, default: false },
  parentWillHandleNext: { type: Boolean, required: false, default: false }
},
  emits: ['nextClicked'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();

__expose({ takeFocus });
const emit = __emit;

const props = __props;

const currentWorkflowStep = ref<WorkflowStep>(null);
const nextWorkflowStep = ref<WorkflowStep>(null);
const workflowStepsCount = ref<number>(0);
const backButton = ref(null);
const nextButton = ref(null);

onMounted(async () => {
  currentWorkflowStep.value = await workflow.getCurrentStep();
  nextWorkflowStep.value = await workflow.getNextStep();
  workflowStepsCount.value = (await workflow.getSteps()).length;
})

const getBackLink = computed<string>(() => {
  return `/${props.backLink}`;
});

const getNextLink = computed<string>(() => {
  return `/${props.nextLink}`;
});

const disable = computed<boolean>(() => {
  return store.state.transactionOngoing;
});

function onBackClicked(event) {
  event.preventDefault();
  workflow.goToPreviousWorkflowStep();
}

function onNextClicked(event) {
  event.preventDefault();

  if (!props.parentWillHandleNext && (props.nextLink?.length ?? 0) > 0) {
    window.location.href = props.nextLink;
    return;
  }

  emit("nextClicked");
}

function takeFocus(key: string): boolean {
  if (key == "back" && props.showBack) {
    backButton.value.focus();
    return true;
  }

  if (key == "next" && props.showNext) {
    nextButton.value.focus();
    return true;
  }

  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.showBack)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              ref_key: "backButton",
              ref: backButton,
              type: "button",
              class: _normalizeClass(["btn-secondary btn d-block d-sm-inline-block p-4 border-end", { 'disabled': disable.value }]),
              href: getBackLink.value,
              onClick: onBackClicked
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
              _createTextVNode(" Back ")
            ]), 10, _hoisted_4))
          : _createCommentVNode("", true),
        (__props.showCustom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn-back btn d-block d-sm-inline-block", { 'disabled': disable.value }]),
                href: __props.customLink
              }, _toDisplayString(__props.customText), 11, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (!__props.showBack && !__props.showCustom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "invisible" }, "Spacer", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(currentWorkflowStep.value?.number ?? '') + " of " + _toDisplayString(workflowStepsCount.value), 1),
        (nextWorkflowStep.value != null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Next: " + _toDisplayString(nextWorkflowStep.value?.text ?? ''), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (__props.showNext)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              ref_key: "nextButton",
              ref: nextButton,
              class: _normalizeClass(["btn-success btn d-block d-sm-inline-block skin-nav-button p-4 border-start", { 'disabled': disable.value }]),
              type: "button",
              href: getNextLink.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onNextClicked($event)))
            }, [
              _createTextVNode(_toDisplayString(__props.nextText) + " ", 1),
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
            ], 10, _hoisted_12))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})